import { render, staticRenderFns } from "./DigitalBookPage.vue?vue&type=template&id=37d5e189&scoped=true&"
import script from "./DigitalBookPage.vue?vue&type=script&lang=js&"
export * from "./DigitalBookPage.vue?vue&type=script&lang=js&"
import style0 from "./DigitalBookPage.vue?vue&type=style&index=0&id=37d5e189&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5e189",
  null
  
)

export default component.exports